<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <div class="toolBar-btn">
          <el-button
          v-access:add
          icon="el-icon-plus"
          @click="add"
          size="small"
          :disabled="isloading"
          type="danger"
          >新增
        </el-button>
        </div>

      </div>
      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="listData"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
          @selection-change="onSelectionChange"
        >
        <el-table-column
            prop="FileName"
            label="文件名称"
          >
            <!-- <template slot-scope="scope">
              <a class="imgaclass" @click="onperview(scope.row)">{{ scope.row.FileName }}</a>
            </template> -->
          </el-table-column>
          <el-table-column
            prop="Sort"
            label="排序号"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column prop="Type" label="类型" width="100" :formatter="formatterType" align="center"></el-table-column>
          
          <el-table-column prop="CreateTime" label="创建时间" width="150" align="center">
            <template slot-scope="scope">
              {{ (scope.row.CreateTime * 1000) | formatDate }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:read
                @click="innerEdit(scope.row)"
                type="text"
                size="mini"
                >编辑
              </el-button>
              <el-button
                v-access:delete
                v-if="isDel(scope.row)"
                @click="innerDel(scope.row)"
                type="text"
                size="mini"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
        <ofImageViewer v-if="isShowimg" :urlList="imageUrlList" @closeImageViewer="closeImageViewer" />
      </div>
    </BasePage>
    <ModuleEdit
      v-if="formVisible"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleEdit>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import ModuleEdit from "./slideEdit";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import { mapGetters } from "vuex";
import api from "@/modules/zjrc/api";
import ofImageViewer from "@/components/controls/of_imageViewer";
import { formatData } from "@/utils/index";
import { saveAs } from "file-saver";

export default {
  name: "list",
  data() {
    return {
      isloading: false,
      listData: [],
      headerRow: "header-row",
      formVisible: false,
      formDataQuery: false,
      formTitle: "",
      formData: {},
      total: 0,
      currentPage: 1,
      pageSize: 15,
      searchModel: {
        searchKey: '',
        startDate: '',
        endDate: ''
      },
      projectName: "",
      placeholder: "单号 / 捐赠项目 / 捐赠者名称",
      // querydate: "",
      startdate: 0,
      enddate: 0,
      isPublic: true,
      ids: [],
      isBtnLoading: false,
      request: {
        Id: '',
        ShowType:0
      },
      queryDate: [],
      isBtnLoadingsum: false,
      isShowimg: false,
      imageUrlList: []
    };
  },
  filters: {
    rounding(value) {
      return value.toFixed(2);
    },
  },
  methods: {
    formatterType(item) {
      if (item.Type === 1) {
        return '图片'
      }else if(item.Type === 2) {
        return '视频'
      }else {
        return '---'
      }
    },
    checkSelectable(row) {
      let flag = true
      if(!row.IsShow&&row.showType==null) {
        flag = false
      }
      return flag
    },
    //初始化数据
    loadData() {
      this.isloading = true;
      this.searchModel.searchKey = this.searchModel.searchKey
        ? this.searchModel.searchKey
        : "";
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        SearchKey: this.searchModel.searchKey,
        startDate: this.searchModel.startDate,
        endDate: this.searchModel.endDate
      };
      api.QuerySlideSetting(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          this.listData = rep.data.Data.rows;
        }
        this.isloading = false;
      });
    },
    add() {
      this.formTitle = "新增";
      this.formData = {Type: 1,Sort:0};
      this.formVisible = true;
    },
    innerEdit(rowData) {
      this.formData = Object.assign({}, rowData);
      this.formTitle = "编辑";
      this.formVisible = true;
    },
    formatterPeriods(rowData) {
      if (rowData.CapitalSource) {
        return rowData.CapitalSource
      }else {
        return "--"
      }
    },
    formCallBack(data) {
      this.formVisible = false;
      this.formDataQuery = false;
      if (data != null) {
        this.loadData();
      }
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 300;
      }
      return tableMaxHeight;
    },
    //删除
    innerDel(rowData) {
      this.$confirm("您确定删除banner图片？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: rowData.Id };
        api.DeleteSlideSettingById(params).then((rep) => {
          if (rep.data.Code === 0) {
            this.$message({
              message: "已删除",
              type: "success",
            });
            this.loadData();
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            });
          }
        });
      });
    },
    onSelectionChange(rowData) {
      let that = this;
      that.isPublic = !rowData.length > 0;
      that.ids = [];
      if (rowData.length) {
        rowData.forEach((item) => {
          that.ids.push(item.Id);
        });
      }
    },
    onperview(item){
      let vm = this
      if (item || item != null) {
        vm.imageUrlList = []
        vm.$http
                .get("/Sys/File/Download?Id=" + item.FileId)
                .then((res) => {
                  vm.imageUrlList.push(res.config.url)
                  vm.isShowimg = true
        });
      }
    },
    closeImageViewer(){
      const vm = this
      vm.isShowimg = false
    },
  },
  components: {
    BasePage,
    OfPagination,
    ModuleEdit,
    ofImageViewer
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
    //确认到账按钮
    isShow() {
      return (rowData) => {
        return rowData.PayType == 3 && rowData.Status == 0 ? true : false;
      };
    },
    //删除按钮
    isDel() {
      return (rowData) => {
        return rowData.UserId ? false : true;
      };
    },
    isShowType() {
      return (rowData) => {
        return rowData.IsShow&&rowData.ShowType===0 ? true: false
      }

    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
.toolBar-search{
  display: flex;
  .search-input{
    width: 220px;
    margin-right: 10px;
  }
  .search-btn{
    height: 40px;
    margin: 8px 5px;
  }
  .search-datePicker{
    margin: 11px 5px 0;
  }
}
</style>

<style scoped>
.el-date-editor >>> .el-input__icon {
  display: none;
}
</style>

<style>
.searchbox {
  float: left;
  margin-right: 1%;
}

.searchbox_right {
  float: right;
  margin-right: 1%;
  widows: 100%;
}
.imgaclass{
  color: #337ab7;
  text-decoration: underline;
  cursor: pointer;
}
</style>
